/* =============================================================================
 * PLACEHOLDER RESULTS — sample data only, NOT real winners.
 * Delete this file once RESULTS_SOURCE in ./config.ts is no longer
 * 'placeholder' (see the instructions there).
 * ========================================================================== */

import type { CandidateType, RoundResult, VenueResult, Winner } from '@shared/types.ts';

const w = (rank: number, name: string, candidate_type: CandidateType, affiliation: string): Winner => ({
  rank,
  name,
  candidate_type,
  affiliation,
});

const venue = (venue_id: string, venue_name: string, city: string, winners: Winner[]): VenueResult => ({
  venue_id,
  venue_name,
  city,
  winners,
});

export const PLACEHOLDER_RESULTS: RoundResult[] = [
  {
    round_id: 'r2',
    round_number: 2,
    round_name: 'दुसरी फेरी',
    held_on: '2027-01-17',
    venues: [
      venue('v-ngp-2', 'वनामती सभागृह', 'नागपूर', [
        w(1, 'सायली देशमुख', 'school', 'भारत विद्यालय, नागपूर · इयत्ता ९वी'),
        w(2, 'अथर्व राऊत', 'school', 'सरस्वती विद्या मंदिर, वर्धा · इयत्ता १०वी'),
        w(1, 'प्रणिती काळे', 'college', 'हिस्लॉप कॉलेज · बी.ए. (इतिहास)'),
        w(2, 'मंदार वाघ', 'college', 'विवेकानंद महाविद्यालय · एम.ए. (मराठी)'),
        w(3, 'विनायक पवार', 'open', 'शिक्षक'),
      ]),
      venue('v-pune-2', 'टिळक स्मारक मंदिर', 'पुणे', [
        w(1, 'ऋतुजा कुलकर्णी', 'school', 'न्यू इंग्लिश स्कूल, पुणे · इयत्ता ८वी'),
        w(2, 'श्रेयस पाटील', 'school', 'ज्ञानदीप विद्यालय, बारामती · इयत्ता १०वी'),
        w(1, 'ओंकार जाधव', 'college', 'फर्ग्युसन महाविद्यालय · बी.एस्सी. (भौतिकशास्त्र)'),
        w(2, 'अमृता गोखले', 'open', 'वकील'),
        w(3, 'सौरभ शिंदे', 'open', 'अभियंता'),
      ]),
    ],
  },
  {
    round_id: 'r1',
    round_number: 1,
    round_name: 'पहिली फेरी',
    held_on: '2026-12-13',
    venues: [
      venue('v-ngp-1', 'धनवटे नॅशनल कॉलेज सभागृह', 'नागपूर', [
        w(1, 'सायली देशमुख', 'school', 'भारत विद्यालय, नागपूर · इयत्ता ९वी'),
        w(2, 'तन्मय भोसले', 'school', 'शिवाजी हायस्कूल, काटोल · इयत्ता ७वी'),
        w(3, 'अथर्व राऊत', 'school', 'सरस्वती विद्या मंदिर, वर्धा · इयत्ता १०वी'),
        w(1, 'प्रणिती काळे', 'college', 'हिस्लॉप कॉलेज · बी.ए. (इतिहास)'),
        w(2, 'मंदार वाघ', 'college', 'विवेकानंद महाविद्यालय · एम.ए. (मराठी)'),
        w(3, 'विनायक पवार', 'open', 'शिक्षक'),
        w(4, 'भक्ती चव्हाण', 'open', 'गृहिणी'),
      ]),
      venue('v-pune-1', 'गणेश कला क्रीडा मंच', 'पुणे', [
        w(1, 'ऋतुजा कुलकर्णी', 'school', 'न्यू इंग्लिश स्कूल, पुणे · इयत्ता ८वी'),
        w(2, 'श्रेयस पाटील', 'school', 'ज्ञानदीप विद्यालय, बारामती · इयत्ता १०वी'),
        w(1, 'ओंकार जाधव', 'college', 'फर्ग्युसन महाविद्यालय · बी.एस्सी. (भौतिकशास्त्र)'),
        w(2, 'केतकी देशपांडे', 'college', 'मॉडर्न कॉलेज · बी.कॉम.'),
        w(3, 'अमृता गोखले', 'open', 'वकील'),
        w(4, 'सौरभ शिंदे', 'open', 'अभियंता'),
      ]),
      venue('v-kop-1', 'केशवराव भोसले नाट्यगृह', 'कोल्हापूर', [
        w(1, 'गौरी निंबाळकर', 'school', 'जिल्हा परिषद प्रशाला, कागल · इयत्ता ६वी'),
        w(2, 'यश मोरे', 'school', 'नूतन मराठी विद्यालय, कोल्हापूर · इयत्ता ९वी'),
        w(1, 'हर्षद गायकवाड', 'college', 'राजर्षी शाहू महाविद्यालय · बी.ए. (इतिहास)'),
        w(2, 'स्नेहल पाटील', 'open', 'बँक कर्मचारी'),
      ]),
      venue('v-csn-1', 'संत एकनाथ रंगमंदिर', 'छत्रपती संभाजीनगर', [
        w(1, 'ईश्वरी जाधव', 'school', 'सरस्वती भुवन प्रशाला · इयत्ता १०वी'),
        w(1, 'रोहन चव्हाण', 'college', 'देवगिरी महाविद्यालय · बी.ई. (संगणक)'),
        w(2, 'वैष्णवी शिंदे', 'college', 'देवगिरी महाविद्यालय · बी.ए. (मराठी)'),
        w(3, 'अक्षय काळे', 'open', 'शेतकरी'),
      ]),
    ],
  },
];
